<template>
  <div class="agreementManage">
    <el-row type="flex">
      <el-col :span="4">
        <div class="agreementBox">
          <div class="searchBox">
            <el-input
              v-model="keyWord"
              placeholder="请输入目录或文档名称"
              clearable
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="filterText"
              />
            </el-input>
          </div>
          <div class="list">
            <el-tree
              ref="tree"
              v-loading="loading"
              :data="list"
              node-key="documentId"
              highlight-current
              :indent="30"
              :filter-node-method="filterNode"
              default-expand-all
              @node-click="handleNodeClick"
            >
              <span
                slot-scope="{ data }"
                class="custom-tree-node"
              >
                <i
                  v-if="data.type==='MENU'"
                  class="el-icon-folder-opened"
                ></i>
                <i
                  v-if="data.type==='DOCUMENT'&&!data.queryLoading"
                  class="el-icon-document"
                ></i>
                <i
                  v-if="data.queryLoading"
                  class="el-icon-loading"
                ></i>
                <span class="label">{{ data.name }}</span>
              </span>
            </el-tree>
          </div>
        </div>
      </el-col>
      <el-col :span="20">
        <div class="contentBox">
          <div
            class="documentContent"
            v-html="selectItem.documentContent"
          ></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { tenementHelpMenuTree, queryTenementHelpMenu } from '@/api/user'
export default {
  components: {
  },
  data() {
    return {
      keyWord: '',
      loading: false,
      list: [],
      selectItem: {},
      initStatus: false
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      tenementHelpMenuTree({ name: this.keyWord, clientType: 'WEB_SITE_C' }).then(res => {
        this.list = res.data.children || []
        if (res.data.children && res.data.children.length > 0 && !this.initStatus) {
          this.initStatus = true
          this.selectItem = res.data.children[0]
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(res.data.children[0].documentId)
          })
        } else {
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.selectItem.documentId)
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleNodeClick(data) {
      this.selectItem = null
      if (data.type === 'DOCUMENT') {
        if (data.queryLoading) {
          return
        }
        this.$set(data, 'queryLoading', true)
        queryTenementHelpMenu({ documentId: data.documentId, clientType: 'WEB_SITE_C' }).then(res => {
          this.selectItem = res.data
        }).finally(() => {
          this.$set(data, 'queryLoading', false)
        })
      }
    },
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    filterText () {
      this.$refs.tree.filter(this.keyWord)
    }
  }

}
</script>

<style lang="scss" scoped>
.agreementManage{
  position: relative;
    .agreementBox{
        background: #fff;
        border-radius: 4px;
        height: 100vh;
        margin-right: 10px;
        padding: 10px;
        border-right: 1px solid #e4e4e4;
        .searchBox{
            display: flex;
            align-items: center;
        }
        .list{
            padding-top: 10px;
            height: calc(100vh - 50px);
            overflow-y: auto;
        }
    }
}
.red{
    color: #ed4848;
}
.green{
    color: #24d224;
}
::v-deep .el-tree-node__expand-icon.is-leaf{
    display: none;
}
.custom-tree-node{
    width: 100%;
    display: flex;
    align-items: center;
    .label{
        font-size: 14px;
        flex: 1;
        padding-left: 6px;
    }
}
.contentBox{
    height: 100vh;
    background: #fff;
    padding-right: 10px;
    padding-top: 10px;
    padding-bottom: 10px;
    .documentContent{
        height: 100%;
        overflow-y: auto;

    }
}
</style>
